export default __webpack_public_path__ + "static/media/Griffin.bce36f0c.svg";